<div class="atlas-table">
  <div class="header-bar mb-21 mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-justify-end mct-items-center">
    <div class="mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-justify-start mct-items-center mct-gap-10">
      <span *ngIf="!searchResult?.TotalCount; else resultsReturned" class="no-results">
        {{ 'committees.edit.committee-meetings.no-search-results' | translate | ucfirst }}
      </span>
      <ng-template #resultsReturned>
        <span>
          {{ 'committees.edit.committee-meetings.the-search-returned' | translate | ucfirst }}
          <strong>{{ searchResult.TotalCount }} {{ 'committees.edit.committee-meetings.meetings' | translate }}</strong>
        </span>
      </ng-template>
      <button
        type="button"
        class="atlas-btn atlas-btn-secondary mct-flex mct-row mct-justify-center mct-items-center"
        (click)="clearSearch()"
      >
        <i class="pi pi-times"></i>
        <span>{{ 'committees.edit.committee-meetings.clear-search' | translate | uppercase }}</span>
      </button>
    </div>
  </div>

  <p-table [showGridlines]="true"
    [value]="searchResult?.Result"
    [paginator]="true"
    [rows]="searchParams ? searchParams.PageSize : 20"
    [totalRecords]="searchResult?.TotalCount"
    (onLazyLoad)="lazyLoad($event)"
    [loading]="loading"
    [lazy]="true"
  >
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="MeetingDate" class="date-column">
          {{ 'committees.edit.committee-meetings.meeting-date' | translate | ucfirst }}
          <p-sortIcon field="MeetingDate"></p-sortIcon>
        </th>
        <th pSortableColumn="Title" class="title-column">
          {{ 'committees.edit.committee-meetings.meeting-title' | translate | ucfirst }}
          <p-sortIcon field="Title"></p-sortIcon>
        </th>
        <th>
          {{ 'committees.edit.committee-meetings.purpose' | translate | ucfirst }}
        </th>
        <th class="actions-column"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-committeeMeeting>
      <tr>
        <td>
          {{ committeeMeeting.MeetingDate | date: 'MM/dd/yyyy' }}
        </td>
        <td>
          <a [routerLink]="['/profiles/committee', committeeMeeting.CommitteeID, 'meeting', committeeMeeting.MeetingID]">
            {{ committeeMeeting.Title }}
          </a>
        </td>
        <td>
          {{ committeeMeeting.Purpose }}
        </td>
        <td>
          <ng-container *wlAccessControl="{ SecurityElement: securityElementNames.Committees_Module, MinimumAccessLevel: 2 }">
            <action-button
              [label]="'committees.edit.committee-meetings.actions' | translate | uppercase"
              [items]="actionItemsForMeeting(committeeMeeting)"
            >
            </action-button>
          </ng-container>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div style="margin-top: -3.3em; float: left">
    <p-select [options]="pagingSizeItems" [(ngModel)]="searchParams.PageSize" (ngModelChange)="pageSizeChanged()" appendTo="body">
    </p-select>
  </div>
  <div style="margin-top: -2.35em; float: right">
    <button pButton type="button" class="atlas-btn atlas-btn-primary mct-flex mct-row mct-justify-center mct-items-center">
      <i class="pi pi-plus"></i>
      <span>{{ 'committees.edit.committee-meetings.export-all-meetings' | translate | uppercase }}</span>
    </button>
  </div>
</div>
